import { Attributes, EnumHelper, LookupBase } from '@singularsystems/neo-core';

export default class DashboardNoteLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public noteId: number = 0;

    @Attributes.Nullable()
    @Attributes.Integer()
    public id: number | null = null;

    public name: string = "";

    public linkType: LinkType = LinkType.Other;

    public noteType: string = "";

    public noteDescription: string = "";

    @Attributes.Date()
    public reminderDate: Date = new Date();

    // Client only properties / methods

    public get isSystemNote() {
        return this.linkType === LinkType.System;
    }

    public getRowClassName() {
        return this.reminderDate < new Date() ? "reminder-expired" : "";
    }

    public get linkTypeIcon() {
        switch (this.linkType) {
            case LinkType.Issuer: return "user-secret";
            case LinkType.Investor: return "user";
            case LinkType.IssuerInvestment: return "university";
            case LinkType.InvestorInvestment: return "coins";
            case LinkType.System: return "user-cog";
        }
        return "question";
    }

    public get linkTypeText() {
        return EnumHelper.getItemMetadata(LinkType, this.linkType).display;
    }
}

export enum LinkType {
    Issuer = 1,
    Investor = 2,
    IssuerInvestment = 3,
    InvestorInvestment = 4,
    System = 5,
    Other = 6,
}